var $6074fcbed6365f88$exports = {};
// Swiper initialization and other functionalities
// import Alpine from 'alpinejs';
// Alpine.start();
document.addEventListener("DOMContentLoaded", ()=>{
    const defaultConfig = {
        slidesPerView: 1,
        spaceBetween: 10,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev"
        },
        loop: true,
        autoplay: {
            delay: 3000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true
        },
        breakpoints: {
            640: {
                slidesPerView: 1,
                spaceBetween: 0
            },
            768: {
                slidesPerView: 1,
                spaceBetween: 0
            },
            1299: {
                slidesPerView: 1,
                spaceBetween: 30
            },
            1499: {
                slidesPerView: 1,
                spaceBetween: 30
            },
            1599: {
                slidesPerView: 1,
                spaceBetween: 30
            }
        }
    };
    const initSwiper = (selector, config)=>new Swiper(selector, config);
    initSwiper(".mySwiper", defaultConfig);
    initSwiper(".mySwiper1", {
        ...defaultConfig,
        navigation: {
            nextEl: ".custom-swiper-button-next",
            prevEl: ".custom-swiper-button-prev"
        },
        breakpoints: {
            640: {
                slidesPerView: 1,
                spaceBetween: 0
            },
            768: {
                slidesPerView: 2,
                spaceBetween: 0
            },
            1024: {
                slidesPerView: 3,
                spaceBetween: 30
            },
            1299: {
                slidesPerView: 3,
                spaceBetween: 30
            },
            1499: {
                slidesPerView: 3,
                spaceBetween: 30
            },
            1599: {
                slidesPerView: 3,
                spaceBetween: 30
            }
        }
    });
    initSwiper(".skeleton_mySwiper1", {
        ...defaultConfig,
        loop: false,
        breakpoints: {
            640: {
                slidesPerView: 1,
                spaceBetween: 0
            },
            768: {
                slidesPerView: 2,
                spaceBetween: 0
            },
            1024: {
                slidesPerView: 3,
                spaceBetween: 10
            },
            1299: {
                slidesPerView: 3,
                spaceBetween: 10
            },
            1499: {
                slidesPerView: 3,
                spaceBetween: 30
            },
            1599: {
                slidesPerView: 3,
                spaceBetween: 30
            }
        }
    });
    initSwiper(".mySwiper2", {
        ...defaultConfig,
        autoplay: {
            delay: 10000,
            disableOnInteraction: false
        }
    });
    initSwiper(".mySwiper3", {
        ...defaultConfig,
        autoplay: {
            delay: 8000,
            disableOnInteraction: false
        },
        lazy: {
            loadPrevNext: true
        }
    });
    initSwiper(".clients_slide .swiper-container", {
        loop: true,
        speed: 500,
        autoplay: {
            delay: 8500,
            disableOnInteraction: false
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev"
        },
        breakpoints: {
            0: {
                slidesPerView: 2,
                spaceBetween: 25
            },
            414: {
                slidesPerView: 3,
                spaceBetween: 25
            },
            768: {
                slidesPerView: 3,
                spaceBetween: 25
            },
            991: {
                slidesPerView: 5,
                spaceBetween: 25
            }
        }
    });
    initSwiper(".mySwiperTestimonials", {
        loop: true,
        speed: 2000,
        autoplay: {
            delay: 3000,
            disableOnInteraction: false
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev"
        },
        breakpoints: {
            0: {
                slidesPerView: 1,
                spaceBetween: 25
            },
            414: {
                slidesPerView: 1,
                spaceBetween: 25
            },
            768: {
                slidesPerView: 1,
                spaceBetween: 25
            },
            991: {
                slidesPerView: 1,
                spaceBetween: 25
            }
        }
    });
    initSwiper(".mySwiperRoadmap", {
        loop: true,
        speed: 500,
        autoplay: {
            delay: 3000,
            disableOnInteraction: false
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev"
        },
        breakpoints: {
            0: {
                slidesPerView: 1,
                spaceBetween: 25
            },
            414: {
                slidesPerView: 1,
                spaceBetween: 25
            },
            768: {
                slidesPerView: 1,
                spaceBetween: 25
            },
            991: {
                slidesPerView: 3,
                spaceBetween: 25
            }
        }
    });
    // Open and close menu
    window.openmenu = ()=>{
        document.getElementById("close-menu").style.display = "block";
        document.getElementById("openmenu").style.display = "none";
    };
    window.closemenu = ()=>{
        document.getElementById("close-menu").style.display = "none";
        document.getElementById("openmenu").style.display = "block";
    };
    // Counter
    const counters = document.querySelectorAll(".counter");
    const speed = 200; // The lower the slower
    counters.forEach((counter)=>{
        const updateCount = ()=>{
            const target = +counter.getAttribute("data-target");
            const count = +counter.innerText;
            const inc = target / speed;
            if (count < target) {
                counter.innerText = count + inc;
                setTimeout(updateCount, 1);
            } else counter.innerText = target;
        };
        updateCount();
    });
    // Service we have section
    const ul = document.getElementById("mainList");
    const liList = ul.querySelectorAll("li");
    const imageList = document.querySelectorAll(".hiddenImage");
    ul.addEventListener("click", (event)=>{
        const { id: id } = event.target;
        liList.forEach((e)=>e.classList.toggle("underlines", e.id === id));
        const sectionId = id.split("_")[1];
        imageList.forEach((e)=>e.classList.toggle("visibleImage", e.id === sectionId));
    });
});


//# sourceMappingURL=adapt.c49370f3.js.map
